class InstitutionList {
	constructor() {
		this.handleSearchFilter();
		this.handleAlphabeticFilter();
		this.handleFilterSelect();
		this.handleSectorFilterSelect();
		this.handleRegionFilterSelect();
		this.handleRegionFilterSelectOption();
		this.handleCityFilterSelect();
		this.handlePaginationList();
		this.handleSinglePageButtons();
		this.handleClearFilters();
	}


	activeLoader() {
		const loader = document.querySelector("#person-register-loader");
		if (loader) {
			loader.classList.remove('hidden');
		}

		const fields = document.querySelectorAll("#person-list-filters input, #person-list-filters button, #person-list-filters select");

		fields.forEach(field => {
			field.setAttribute('disabled', 'true');
		});
	}

	handleAlphabeticFilter() {
		const letters = document.querySelectorAll('#person-list-alphabetic-filter > button');

		letters.forEach(letter => {
			letter.addEventListener('click', () => {
				const letterData = letter.getAttribute('data-letter');

				if (letterData) {
					const url = new URL(window.location.href);
					url.searchParams.set('letter', letterData);

					if (url.pathname.includes('/page/')) {
						url.pathname = url.pathname.replace(/\/page\/\d+\/?$/, '/');
					}

					this.activeLoader();
					location.replace(url.toString());
				}
			});
		});
	}

	handleSearchFilter() {
		const form = document.querySelector('#person-list-search-form');
		const input = document.querySelector('#person-list-search-input');

		if (form) {
			form.addEventListener('submit', (e) => {
				e.preventDefault();

				const url = new URL(window.location.href);
				url.searchParams.delete('search');

				if (input.value) {
					url.searchParams.set('search', input.value);
				}

				this.activeLoader();
				location.replace(url.toString());
			});
		}
	}

	handleClearFilters() {
		const button = document.querySelector('#person-list-clear-filters');

		if (button) {
			button.addEventListener('click', () => {
				const url = new URL(window.location.href);
				url.search = '';

				this.activeLoader();
				location.replace(url.toString());
			});
		}
	}

	handleFilterSelect() {
		const select = document.querySelector('#person-list-role-select');

		if (select) {
			select.addEventListener('change', () => {
				const url = new URL(window.location.href);

				url.searchParams.delete('role');

				if (select.value) {
					url.searchParams.set('role', select.value);
				}

				if (url.pathname.includes('/page/')) {
					this.activeLoader();
  					location.replace(url.pathname.replace(/\/page\/\d+\/?$/, '/'));
				}

				this.activeLoader();
				location.replace(url.toString());
			});
		}
	}


	handleCityFilterSelect() {
		const select = document.querySelector('#person-list-city-select');

		if (select) {
			select.addEventListener('change', () => {
				const url = new URL(window.location.href);
				url.searchParams.delete('city');

				if (select.value) {
					url.searchParams.set('city', select.value);
				}

				this.activeLoader();
				location.replace(url.toString());
			});
		}
	}

	handleSinglePageButtons() {
		const buttons = document.querySelectorAll('button.person-single-button');

		buttons.forEach(button => {
			button.addEventListener('click', () => {
				const url = button.getAttribute('data-url');
				if (url) {
					this.activeLoader();
					location.replace(url);
				}
			});
		});
	}


	handleRegionFilterSelectOption() {
		const regionSelect = document.querySelector('#person-list-region-select');

		if (regionSelect) {
			const selectedOption = regionSelect.options[regionSelect.selectedIndex];

			if (selectedOption) {
				this.setSectorOptions(selectedOption);
			}
		}
	}

	setSectorOptions(selectedOption) {

		if (!selectedOption.getAttribute('data-item')) {
			return;
		}

		const data = JSON.parse(selectedOption.getAttribute('data-item'));

		const sectorsSelect = document.querySelector('#person-list-sector-select');

		if (!sectorsSelect) {
			return;
		}

		const currentSector = sectorsSelect.getAttribute('data-sector');
		const sectorLabel = sectorsSelect.getAttribute('data-sector-label') || 'Setor';

		if (data.sectors) {
			sectorsSelect.innerHTML = `<option value="">Selecione um ${sectorLabel}</option>`;
		}

		data.sectors.forEach(sector => {
			const option = document.createElement('option');
			option.value = sector.id;
			option.innerText = sector.name;

			if (currentSector == sector.id) {
				option.selected = true;
			}

			sectorsSelect.appendChild(option);
		});
	}

	handleSectorFilterSelect() {
		const select = document.querySelector('#person-list-sector-select');

		if (select) {
			select.addEventListener('change', () => {
				const url = new URL(window.location.href);
				url.searchParams.delete('setor');

				if (select.value) {
					url.searchParams.set('setor', select.value);
				}

				this.activeLoader();
				location.replace(url.toString());
			});
		}
	}

	handleRegionFilterSelect() {
		const select = document.querySelector('#person-list-region-select');

		if (select) {
			select.addEventListener('change', () => {
				const url = new URL(window.location.href);
				url.searchParams.delete('region');
				url.searchParams.delete('sector');

				if (select.value) {
					url.searchParams.set('region', select.value);
				}

				this.activeLoader();
				location.replace(url.toString());
			});
		}
	}

	handlePaginationList() {
		const paginationItems = document.querySelectorAll('.pagination-item');

		paginationItems.forEach(item => {
			const page = item.getAttribute('data-page');

			if (page) {
				const url = new URL(window.location.href);
				item.href = `${item.href}page/${page}/?${url.searchParams.toString()}`;
			}
		});
	}
}


document.addEventListener('DOMContentLoaded', () => {
	new InstitutionList();
});
